/** Auto-synced from server — run: node server/scripts/sync-email-template-defaults.js */
export const NOTIFICATION_EVENT_IDS = [
  "credentials",
  "welcome",
  "candidate_registered_admin",
  "candidate_registered_recruiter",
  "profile_completion",
  "password_reset",
  "password_changed",
  "job_created_client",
  "job_created_recruiter",
  "job_created_admin",
  "job_recommended_candidate",
  "candidate_referral_recruiter",
  "candidate_referral_admin",
  "job_status_client",
  "job_status_recruiter",
  "job_status_admin",
  "recruiter_assigned_client",
  "recruiter_assigned_recruiter",
  "application_submitted_candidate",
  "application_submitted_client",
  "application_submitted_recruiter",
  "application_stage_candidate",
  "application_stage_client",
  "application_stage_recruiter",
  "application_stage_admin",
  "interview_activity_candidate",
  "interview_activity_client",
  "interview_activity_recruiter",
  "offer_activity_candidate",
  "offer_activity_client",
  "offer_activity_recruiter",
  "offer_document_candidate",
  "offer_document_client",
  "offer_document_recruiter"
];

export const EMAIL_TEMPLATE_DEFAULTS = {
  "credentials": {
    "subject": "Welcome to {{companyName}} — your {{roleLabel}} account",
    "bodyText": "Dear {{recipientName}},\n\nYour account has been created on {{companyName}}.\n\nRole: {{roleLabel}}\nLogin email: {{loginEmail}}\nTemporary password: {{password}}\n\nPortal: {{loginUrl}}\n\nPlease sign in and change your password after your first login.",
    "buttonLabel": "Sign in to portal",
    "buttonPath": "/login"
  },
  "welcome": {
    "subject": "Welcome to {{companyName}}",
    "bodyText": "Dear {{recipientName}},\n\nYour candidate account has been created on {{companyName}}.\n\nLogin email: {{loginEmail}}\nPortal: {{loginUrl}}\n\nSign in to complete your profile and track your applications.",
    "buttonLabel": "Sign in to portal",
    "buttonPath": "/login"
  },
  "profile_completion": {
    "subject": "Please complete your profile — {{companyName}}",
    "bodyText": "Dear {{recipientName}},\n\nWe noticed your candidate profile on {{companyName}} is incomplete.\n\nCandidate ID: {{candidateId}}\nLogin email: {{loginEmail}}\n\nPlease sign in and update your education, experience, skills, resume, and contact details so recruiters can match you to suitable roles.\n\nPortal: {{loginUrl}}",
    "buttonLabel": "Complete my profile",
    "buttonPath": "/profile"
  },
  "candidate_registered_admin": {
    "subject": "New candidate registration — {{candidateName}}",
    "bodyText": "A new candidate registered on {{companyName}}.\n\nName: {{candidateName}}\nEmail: {{candidateEmail}}\nPhone: {{candidatePhone}}\nCandidate ID: {{candidateId}}\n\nRegistered at: {{portalUrl}}",
    "buttonLabel": "View candidates",
    "buttonPath": "/candidates"
  },
  "candidate_registered_recruiter": {
    "subject": "New candidate registration — {{candidateName}}",
    "bodyText": "Hello {{recipientName}},\n\nA new candidate has registered on the portal.\n\nName: {{candidateName}}\nEmail: {{candidateEmail}}\nPhone: {{candidatePhone}}\nCandidate ID: {{candidateId}}\n\nReview their profile in the candidates list when ready.",
    "buttonLabel": "View candidates",
    "buttonPath": "/candidates"
  },
  "password_reset": {
    "subject": "Reset your {{companyName}} password",
    "bodyText": "Dear {{recipientName}},\n\nWe received a request to reset the password for {{loginEmail}}.\n\nUse this link within 1 hour (one-time use):\n{{resetUrl}}\n\nIf you did not request this, ignore this email.",
    "buttonLabel": "Reset password",
    "buttonPath": "/reset-password"
  },
  "password_changed": {
    "subject": "Your {{companyName}} password was changed",
    "bodyText": "Dear {{recipientName}},\n\nThe password for {{loginEmail}} was changed successfully.\n\nIf you did not make this change, contact your administrator immediately.\n\nPortal: {{loginUrl}}",
    "buttonLabel": "Sign in to portal",
    "buttonPath": "/login"
  },
  "job_created": {
    "subject": "New job posted: {{jobTitle}}",
    "bodyText": "A new job requisition is available.\n\nJob: {{jobTitle}}\nJob ID: {{jobId}}\nClient: {{clientName}}\nLocation: {{jobLocation}}\nPositions: {{jobPositions}}\nStatus: {{jobStatus}}\n\nPosted by: {{actorName}}\n\nOpen the portal to view details.",
    "buttonLabel": "View jobs",
    "buttonPath": "/jobs"
  },
  "job_status": {
    "subject": "Job status update: {{jobTitle}} — {{jobStatus}}",
    "bodyText": "The hiring status for a job has been updated.\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nPrevious status: {{previousStatus}}\nNew status: {{jobStatus}}\nNote: {{message}}\n\nUpdated by: {{actorName}}",
    "buttonLabel": "View job",
    "buttonPath": "/jobs"
  },
  "recruiter_assigned": {
    "subject": "You are assigned to job: {{jobTitle}}",
    "bodyText": "Hello {{recipientName}},\n\nYou have been assigned as the recruiter for the following job.\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nLocation: {{jobLocation}}\n\nAssigned by: {{actorName}}",
    "buttonLabel": "Open ATS",
    "buttonPath": "/applications"
  },
  "application_submitted": {
    "subject": "New application: {{candidateName}} → {{jobTitle}}",
    "bodyText": "A candidate has been submitted to the hiring pipeline.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\nClient: {{clientName}}\nStage: Submitted\nApplication ID: {{applicationId}}\n\nSubmitted by: {{actorName}}\nNotes: {{message}}",
    "buttonLabel": "Review application",
    "buttonPath": "/applications"
  },
  "application_stage": {
    "subject": "Application {{stage}}: {{candidateName}} — {{jobTitle}}",
    "bodyText": "An application stage has been updated.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\nClient: {{clientName}}\nPrevious stage: {{previousStage}}\nNew stage: {{stage}}\nApplication ID: {{applicationId}}\n\nUpdated by: {{actorName}}\nNotes: {{message}}",
    "buttonLabel": "View application",
    "buttonPath": "/applications"
  },
  "interview_activity": {
    "subject": "Interview update: {{candidateName}} — {{jobTitle}}",
    "bodyText": "There is an update regarding a scheduled interview.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\nClient: {{clientName}}\nActivity: {{eventLabel}}\nApplication ID: {{applicationId}}\n\nBy: {{actorName}}\n\n{{interviewDetails}}",
    "buttonLabel": "View in portal",
    "buttonPath": "/applications"
  },
  "offer_activity": {
    "subject": "Offer update: {{candidateName}} — {{jobTitle}}",
    "bodyText": "There is an update on an offer in your recruitment pipeline.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\nClient: {{clientName}}\nActivity: {{eventLabel}}\nApplication ID: {{applicationId}}\n\nBy: {{actorName}}\nMessage: {{message}}",
    "buttonLabel": "View in portal",
    "buttonPath": "/applications"
  },
  "offer_document": {
    "subject": "Document uploaded: {{documentLabel}} — {{candidateName}}",
    "bodyText": "A candidate has uploaded an onboarding document.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\nClient: {{clientName}}\nDocument: {{documentLabel}}\nApplication ID: {{applicationId}}\n\nUploaded by: {{actorName}}",
    "buttonLabel": "Review documents",
    "buttonPath": "/applications"
  },
  "job_created_client": {
    "subject": "New job requisition: {{jobTitle}}",
    "bodyText": "Dear {{recipientName}},\n\nA new job has been posted for {{clientName}}.\n\nJob: {{jobTitle}}\nLocation: {{jobLocation}}\nPositions: {{jobPositions}}\nStatus: {{jobStatus}}\n\nPosted by: {{actorName}}\n\nSign in to review the requisition and track hiring progress.",
    "buttonLabel": "View my jobs",
    "buttonPath": "/jobs"
  },
  "job_created_recruiter": {
    "subject": "New job available: {{jobTitle}} ({{clientName}})",
    "bodyText": "Hello {{recipientName}},\n\nA new job requisition is available on the portal.\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nLocation: {{jobLocation}}\nPositions: {{jobPositions}}\n\nPosted by: {{actorName}}",
    "buttonLabel": "View jobs",
    "buttonPath": "/jobs"
  },
  "job_created_admin": {
    "subject": "New job posted: {{jobTitle}}",
    "bodyText": "A new job requisition was created.\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nLocation: {{jobLocation}}\nPositions: {{jobPositions}}\nStatus: {{jobStatus}}\n\nPosted by: {{actorName}}",
    "buttonLabel": "View jobs",
    "buttonPath": "/jobs"
  },
  "job_recommended_candidate": {
    "subject": "Recommended for you: {{jobTitle}} ({{clientName}})",
    "bodyText": "Dear {{recipientName}},\n\nWe found a job that matches your skills on the portal.\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nLocation: {{jobLocation}}\nPositions: {{jobPositions}}\n\nSign in to review the role details and apply. Applying will create an ATS entry at Submitted and notify the recruiter and admin.",
    "buttonLabel": "View suitable jobs",
    "buttonPath": "/suitable-jobs"
  },
  "candidate_referral_recruiter": {
    "subject": "New candidate referral: {{candidateName}} for {{jobTitle}}",
    "bodyText": "A candidate referral was submitted from the candidate portal.\n\nReferred candidate: {{candidateName}}\nJob: {{jobTitle}}\nClient: {{clientName}}\nMessage: {{message}}\n\nSubmitted by: {{actorName}}",
    "buttonLabel": "View referrals",
    "buttonPath": "/referrals"
  },
  "candidate_referral_admin": {
    "subject": "Candidate referral submitted: {{candidateName}}",
    "bodyText": "A new referral has been added and credentials were sent to the referred person.\n\nReferred candidate: {{candidateName}}\nJob: {{jobTitle}}\nClient: {{clientName}}\nMessage: {{message}}\n\nSubmitted by: {{actorName}}",
    "buttonLabel": "View referrals",
    "buttonPath": "/referrals"
  },
  "job_status_client": {
    "subject": "Your job {{jobTitle}} — status is now {{jobStatus}}",
    "bodyText": "Dear {{recipientName}},\n\nThe hiring status for your job has been updated.\n\nJob: {{jobTitle}}\nPrevious status: {{previousStatus}}\nNew status: {{jobStatus}}\nNote: {{message}}\n\nUpdated by: {{actorName}}",
    "buttonLabel": "View my jobs",
    "buttonPath": "/jobs"
  },
  "job_status_recruiter": {
    "subject": "Job status: {{jobTitle}} — {{jobStatus}}",
    "bodyText": "Job status update for {{clientName}}.\n\nJob: {{jobTitle}}\nPrevious status: {{previousStatus}}\nNew status: {{jobStatus}}\nNote: {{message}}\n\nUpdated by: {{actorName}}",
    "buttonLabel": "View job",
    "buttonPath": "/jobs"
  },
  "job_status_admin": {
    "subject": "Job status update: {{jobTitle}} — {{jobStatus}}",
    "bodyText": "Job: {{jobTitle}} ({{clientName}})\n{{previousStatus}} → {{jobStatus}}\n{{message}}\nBy: {{actorName}}",
    "buttonLabel": "View jobs",
    "buttonPath": "/jobs"
  },
  "recruiter_assigned_client": {
    "subject": "Recruiter assigned to {{jobTitle}}",
    "bodyText": "Dear {{recipientName}},\n\nA recruiter has been assigned to your job.\n\nJob: {{jobTitle}}\nRecruiter: {{actorName}}\n\nYou can track submissions and interviews in the portal.",
    "buttonLabel": "View my jobs",
    "buttonPath": "/jobs"
  },
  "recruiter_assigned_recruiter": {
    "subject": "You are assigned to job: {{jobTitle}}",
    "bodyText": "Hello {{recipientName}},\n\nYou have been assigned as recruiter for:\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nLocation: {{jobLocation}}\n\nAssigned by: {{actorName}}",
    "buttonLabel": "Open ATS",
    "buttonPath": "/applications"
  },
  "application_submitted_candidate": {
    "subject": "Application received: {{jobTitle}} at {{clientName}}",
    "bodyText": "Dear {{recipientName}},\n\nThank you — your application has been submitted successfully.\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nApplication ID: {{applicationId}}\nCurrent stage: Submitted\n\nWe will notify you when there are updates.",
    "buttonLabel": "My applications",
    "buttonPath": "/my-applications"
  },
  "application_submitted_client": {
    "subject": "New candidate for {{jobTitle}}: {{candidateName}}",
    "bodyText": "Dear {{recipientName}},\n\nA new candidate has been submitted for your job.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\nApplication ID: {{applicationId}}\n\nSubmitted by: {{actorName}}\nNotes: {{message}}",
    "buttonLabel": "View submissions",
    "buttonPath": "/applications"
  },
  "application_submitted_recruiter": {
    "subject": "New submission: {{candidateName}} → {{jobTitle}}",
    "bodyText": "Candidate {{candidateName}} was submitted for {{jobTitle}} ({{clientName}}).\n\nApplication ID: {{applicationId}}\nSubmitted by: {{actorName}}\nNotes: {{message}}",
    "buttonLabel": "Review in ATS",
    "buttonPath": "/applications"
  },
  "application_stage_candidate": {
    "subject": "Your application update: {{stage}} — {{jobTitle}}",
    "bodyText": "Dear {{recipientName}},\n\nYour application status has changed.\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nPrevious stage: {{previousStage}}\nNew stage: {{stage}}\nApplication ID: {{applicationId}}\n\n{{message}}\n\nUpdated by: {{actorName}}",
    "buttonLabel": "My applications",
    "buttonPath": "/my-applications"
  },
  "application_stage_client": {
    "subject": "Candidate {{candidateName}} — stage {{stage}} ({{jobTitle}})",
    "bodyText": "Dear {{recipientName}},\n\nAn application on your job was updated.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\n{{previousStage}} → {{stage}}\nApplication ID: {{applicationId}}\n\n{{message}}\n\nBy: {{actorName}}",
    "buttonLabel": "View submissions",
    "buttonPath": "/applications"
  },
  "application_stage_recruiter": {
    "subject": "Stage {{stage}}: {{candidateName}} — {{jobTitle}}",
    "bodyText": "Application stage update.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}} ({{clientName}})\n{{previousStage}} → {{stage}}\nApplication ID: {{applicationId}}\n\n{{message}}\n\nBy: {{actorName}}",
    "buttonLabel": "Open ATS",
    "buttonPath": "/applications"
  },
  "application_stage_admin": {
    "subject": "Joined: {{candidateName}} — {{jobTitle}}",
    "bodyText": "Candidate marked as joined.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}} ({{clientName}})\nApplication ID: {{applicationId}}\n\n{{message}}\n\nBy: {{actorName}}",
    "buttonLabel": "View application",
    "buttonPath": "/applications"
  },
  "interview_activity_candidate": {
    "subject": "Interview update: {{jobTitle}} — {{eventLabel}}",
    "bodyText": "Dear {{recipientName}},\n\nThere is an update about your interview.\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nActivity: {{eventLabel}}\nApplication ID: {{applicationId}}\n\n{{interviewDetails}}\n\nSign in to view your application or reschedule if needed.",
    "buttonLabel": "My applications",
    "buttonPath": "/my-applications"
  },
  "interview_activity_client": {
    "subject": "Interview: {{candidateName}} — {{eventLabel}}",
    "bodyText": "Dear {{recipientName}},\n\nInterview activity for your candidate.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\nClient: {{clientName}}\nActivity: {{eventLabel}}\nApplication ID: {{applicationId}}\n\n{{interviewDetails}}\n\nBy: {{actorName}}",
    "buttonLabel": "View submissions",
    "buttonPath": "/applications"
  },
  "interview_activity_recruiter": {
    "subject": "Interview: {{candidateName}} — {{eventLabel}}",
    "bodyText": "Candidate: {{candidateName}}\nJob: {{jobTitle}} ({{clientName}})\nActivity: {{eventLabel}}\nApplication ID: {{applicationId}}\n\n{{interviewDetails}}\n\nBy: {{actorName}}",
    "buttonLabel": "Open ATS",
    "buttonPath": "/applications"
  },
  "offer_activity_candidate": {
    "subject": "Offer update: {{jobTitle}} — {{eventLabel}}",
    "bodyText": "Dear {{recipientName}},\n\nThere is an update regarding your job offer.\n\nJob: {{jobTitle}}\nClient: {{clientName}}\nActivity: {{eventLabel}}\n\n{{message}}\n\nPlease sign in to respond (accept, negotiate, or decline).",
    "buttonLabel": "Respond to offer",
    "buttonPath": "/my-applications"
  },
  "offer_activity_client": {
    "subject": "Offer: {{candidateName}} — {{eventLabel}}",
    "bodyText": "Dear {{recipientName}},\n\nOffer activity on your requisition.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\nActivity: {{eventLabel}}\n\n{{message}}\n\nBy: {{actorName}}",
    "buttonLabel": "View submissions",
    "buttonPath": "/applications"
  },
  "offer_activity_recruiter": {
    "subject": "Offer: {{candidateName}} — {{eventLabel}}",
    "bodyText": "Candidate: {{candidateName}}\nJob: {{jobTitle}} ({{clientName}})\n{{eventLabel}}\n\n{{message}}\n\nBy: {{actorName}}",
    "buttonLabel": "Open ATS",
    "buttonPath": "/applications"
  },
  "offer_document_candidate": {
    "subject": "We received your document: {{documentLabel}}",
    "bodyText": "Dear {{recipientName}},\n\nYour upload was received successfully.\n\nDocument: {{documentLabel}}\nJob: {{jobTitle}}\nApplication ID: {{applicationId}}\n\nThank you.",
    "buttonLabel": "My applications",
    "buttonPath": "/my-applications"
  },
  "offer_document_client": {
    "subject": "Document from {{candidateName}}: {{documentLabel}}",
    "bodyText": "Dear {{recipientName}},\n\nThe candidate uploaded an onboarding document.\n\nCandidate: {{candidateName}}\nJob: {{jobTitle}}\nDocument: {{documentLabel}}\nApplication ID: {{applicationId}}\n\nUploaded by: {{actorName}}",
    "buttonLabel": "Review documents",
    "buttonPath": "/applications"
  },
  "offer_document_recruiter": {
    "subject": "Document uploaded: {{documentLabel}} — {{candidateName}}",
    "bodyText": "{{candidateName}} uploaded {{documentLabel}} for {{jobTitle}} ({{clientName}}).\n\nApplication ID: {{applicationId}}\nBy: {{actorName}}",
    "buttonLabel": "Review documents",
    "buttonPath": "/applications"
  }
};

export function resolveTemplateContent(eventType, stored, catalogEntry) {
  const def = EMAIL_TEMPLATE_DEFAULTS[eventType] || {};
  const cat = catalogEntry || {};
  const subject =
    (stored?.subject || '').trim() ||
    (cat.override?.subject || '').trim() ||
    cat.defaultSubject ||
    def.subject ||
    '';
  const bodyText =
    (stored?.bodyText || '').trim() ||
    (cat.override?.bodyText || '').trim() ||
    cat.defaultBodyText ||
    def.bodyText ||
    '';
  return {
    subject,
    bodyText,
    buttonLabel: cat.buttonLabel || def.buttonLabel,
    buttonPath: cat.buttonPath || def.buttonPath
  };
}

export function fillAllEmailTemplates(emailTemplates = {}, catalogTemplates = []) {
  const catalogMap = Object.fromEntries((catalogTemplates || []).map(t => [t.eventType, t]));
  const result = { ...emailTemplates };
  for (const ev of NOTIFICATION_EVENT_IDS) {
    result[ev] = resolveTemplateContent(ev, result[ev], catalogMap[ev]);
  }
  return result;
}
